"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: auto-reload/auto-reload-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fauto-reload%2Fauto-reload-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoReloadServiceClient = exports.GetResponse = exports.GetRequest = exports.SetResponse = exports.SetRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const auto_reload_1 = require("./auto-reload");
const protobufPackage = 'com.step.autoreload.proto';
function createBaseSetRequest() {
    return {
        reloadAmount: amount_1.Amount.fromPartial({}),
        minBalance: amount_1.Amount.fromPartial({}),
        sourceExternalAccountId: '',
        enabled: false,
    };
}
exports.SetRequest = {
    fromJSON(object) {
        const message = {
            reloadAmount: isSet(object.reloadAmount)
                ? amount_1.Amount.fromJSON(object.reloadAmount)
                : amount_1.Amount.fromPartial({}),
            minBalance: isSet(object.minBalance)
                ? amount_1.Amount.fromJSON(object.minBalance)
                : amount_1.Amount.fromPartial({}),
            sourceExternalAccountId: isSet(object.sourceExternalAccountId)
                ? globalThis.String(object.sourceExternalAccountId)
                : '',
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reloadAmount !== undefined) {
            obj.reloadAmount = amount_1.Amount.toJSON(message.reloadAmount);
        }
        if (message.minBalance !== undefined) {
            obj.minBalance = amount_1.Amount.toJSON(message.minBalance);
        }
        if (message.sourceExternalAccountId !== '') {
            obj.sourceExternalAccountId = message.sourceExternalAccountId;
        }
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return exports.SetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetRequest();
        message.reloadAmount = (object.reloadAmount !== undefined && object.reloadAmount !== null)
            ? amount_1.Amount.fromPartial(object.reloadAmount)
            : amount_1.Amount.fromPartial({});
        message.minBalance = (object.minBalance !== undefined && object.minBalance !== null)
            ? amount_1.Amount.fromPartial(object.minBalance)
            : amount_1.Amount.fromPartial({});
        message.sourceExternalAccountId = object.sourceExternalAccountId ?? '';
        message.enabled = object.enabled ?? false;
        return message;
    },
};
function createBaseSetResponse() {
    return { autoReload: auto_reload_1.AutoReload.fromPartial({}) };
}
exports.SetResponse = {
    fromJSON(object) {
        const message = {
            autoReload: isSet(object.autoReload)
                ? auto_reload_1.AutoReload.fromJSON(object.autoReload)
                : auto_reload_1.AutoReload.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.autoReload !== undefined) {
            obj.autoReload = auto_reload_1.AutoReload.toJSON(message.autoReload);
        }
        return obj;
    },
    create(base) {
        return exports.SetResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetResponse();
        message.autoReload = (object.autoReload !== undefined && object.autoReload !== null)
            ? auto_reload_1.AutoReload.fromPartial(object.autoReload)
            : auto_reload_1.AutoReload.fromPartial({});
        return message;
    },
};
function createBaseGetRequest() {
    return {};
}
exports.GetRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetRequest();
        return message;
    },
};
function createBaseGetResponse() {
    return { autoReload: undefined };
}
exports.GetResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.autoReload)) {
            message.autoReload = auto_reload_1.AutoReload.fromJSON(object.autoReload);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.autoReload !== undefined) {
            obj.autoReload = auto_reload_1.AutoReload.toJSON(message.autoReload);
        }
        return obj;
    },
    create(base) {
        return exports.GetResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetResponse();
        message.autoReload = (object.autoReload !== undefined && object.autoReload !== null)
            ? auto_reload_1.AutoReload.fromPartial(object.autoReload)
            : undefined;
        return message;
    },
};
/**
 * Auto Reload Service API.
 */
class AutoReloadServiceClient {
    rpc;
    name = 'com.step.autoreload.proto.AutoReloadService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/auto-reload';
    methods = [{
            name: 'Set',
            requestType: exports.SetRequest,
            responseType: exports.SetResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Get',
            requestType: exports.GetRequest,
            responseType: exports.GetResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    set(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    get(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.AutoReloadServiceClient = AutoReloadServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=auto-reload-service.js.map